import moment from "moment";
import "moment/locale/da";
import CertTestAdminApp from "./CertTestAdminApp";

moment.locale("da");

new CertTestAdminApp();
